import styled, { css } from "styled-components/native";
import { rgba } from "polished";
import { TouchableHighlight, Text } from "react-native";
import { EventsProps } from "./types";
import { borderRadius, compose } from "../../theming/styledSystem";

const buttonStyles = compose(borderRadius);

export const StyledTouchableHighlight = styled(TouchableHighlight)<EventsProps>`
  height: 32px;
  align-self: flex-start;
  justify-content: center;
  background-color: ${({ theme }) => theme.colorTokens.component.input.surface};
  padding-left: ${({ theme, isCondensed }) =>
    isCondensed ? 10 : theme.space["space-5"]};
  padding-right: ${({ theme, isCondensed }) =>
    isCondensed ? 10 : theme.space["space-5"]};
  ${({ isHovered, isPressed, isSelected, theme }) =>
    (isHovered || isSelected) &&
    css`
      background-color: ${isPressed
        ? theme.colorTokens.component.button.buttonLink
        : theme.colorTokens.component.button.tertiary.background.hover};
    `}
  ${({ isCondensed, theme }) =>
    !isCondensed &&
    css`
      box-shadow: 0 1px 3px ${rgba(17, 43, 68, 0.12)};
      margin-right: 8px;
      height: 44px;
      border-width: 1px;
      border-radius: ${theme.radii.xs};
      border-color: ${theme.colorTokens.border.default};
    `}
  ${({ isHovered, isCondensed }) =>
    isHovered &&
    !isCondensed &&
    css`
      box-shadow: 0 2px 4px ${rgba(17, 43, 68, 0.14)};
    `}
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.colorTokens.component.button.buttonLink
        .background.active};
      border-color: ${theme.colorTokens.border.default};
      box-shadow: none;
    `};
  ${({ isPressed, theme }) =>
    isPressed &&
    css`
      border-color: ${theme.colorTokens.border.default};
      background-color: ${theme.colorTokens.component.button.tertiary.background
        .hover};
      box-shadow: none;
    `}

  ${buttonStyles};
`;

export const StyledText = styled(Text)<EventsProps>`
  display: flex;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.medium};
  font-size: ${({ theme }) => theme.fontSizes.s};
  color: ${({ theme }) => theme.colorTokens.content.default};
  ${({ isHovered, theme }) =>
    isHovered &&
    css`
      color: ${theme.colorTokens.content.default};
    `}
  ${({ isPressed, theme }) =>
    isPressed &&
    css`
      color: ${theme.colorTokens.content.default};
    `}
  ${({ isSelected, isPressed, theme }) =>
    isSelected &&
    !isPressed &&
    css`
      color: ${theme.colorTokens.component.button.buttonLink.content.active};
    `}
`;
